module.exports = __webpack_public_path__ + "static/media/three.0416a7b1.jpg";